module.exports = __webpack_public_path__ + "static/media/pic3.dac66969.png";